<script>
	export let tag;
	let campaignName = "nc-renault";
	const baseURL = `https://native-count.netlify.app/.netlify/functions/fetch/?articleID=${campaignName}`;
	$: interactionURL = `${baseURL}-${tag}`;

	const local = document.location.href.includes("localhost");

	$: if (local) {
		console.log(interactionURL);
	}
</script>

{#if !local}
	<img src={interactionURL} role="presentation" alt="" />
{/if}

<style>
	img {
		opacity: 0;
	}
</style>
